module.exports = __webpack_public_path__ + "img/Medias.a9784ac1.svg";